import { createStore } from "vuex";
import savedJobs from "./modules/savedJobs";
import hiddenJobs from "./modules/hiddenJobs";
import notifications from "./modules/notifications";

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    savedJobs,
    hiddenJobs,
    notifications,
  },
});
